var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        visible: _vm.show,
        "body-class": "p-0",
        "modal-class": "asset-modal",
        size: "xl",
        title: "Asset Manager"
      },
      on: {
        ok: _vm.pickAssets,
        cancel: _vm.closeModal,
        hide: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _vm.initialized
        ? _c("p", [_vm._v("Loading...")])
        : _c(
            "div",
            [
              _c("file-manager-component", {
                attrs: {
                  getData: _vm.getData,
                  replaceData: _vm.replaceData,
                  createData: _vm.modifiedCreateData,
                  updateBatch: _vm.modifiedUpdateBatch,
                  addNotification: _vm.addNotification,
                  content: _vm.content,
                  timestamp: _vm.timestamp,
                  currentValue: _vm.value,
                  allowedExtensions: _vm.extensions,
                  multiple: _vm.multiple,
                  storagePanel: _vm.storagePanel,
                  storages: _vm.storages,
                  embedded: true,
                  hide: !_vm.show
                },
                on: {
                  "fm::asset::select": _vm.selectAsset,
                  "fm::asset::dblclick": _vm.getAsset
                }
              })
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51240302", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51240302","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/FileModalComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-51240302","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/FileModalComponent.vue
// module chunks = 0